import React from 'react';
import { arrayOf, bool, number, shape, string } from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { FunnelBar, FunnelStepDescription } from './components';
import { LoadingRectangle, Overlay } from '../../global-styles/components';
import UpgradeOverlay from '../UpgradeOverlay';

import fullFunnel from '../../assets/images/full-funnel.png';

import staticText from '../../localization/Application/ConnectInsights/connectInsights';

const loadingAndEmptyBlur = {
  filter: 'blur(4px)',
  opacity: '50%',
};

const ConnectInsightsFunnel = ({
  funnel, funnelGated, isFetching, showLoading,
}) => {
  const theme = useTheme();

  const funnelEmpty = funnel.every(event => event.count === '0');
  let formattedFunnel = funnel;
  if (funnelEmpty || funnelGated) {
    formattedFunnel = funnel.map((event) => {
      return {
        ...event,
        percent: '0.00',
        previousStagePercent: '1.00',
      };
    });
  }

  return (
    <Box display="grid">
      {funnelGated && (
        <React.Fragment>
          <UpgradeOverlay staticText={staticText.upgradeContent} />
          <img
            src={fullFunnel}
            alt="Conversion funnel"
            style={{
              width: '100%',
              gridRow: 1,
              gridColumn: 1,
              marginTop: theme.spacing(3),
            }}
          />
        </React.Fragment>
      )}
      {!funnelGated && (
        <React.Fragment>
          {isFetching && <LoadingRectangle sx={{ height: '287px' }} data-testid="loading-rectangle" />}
          {!isFetching && funnelEmpty && (
            <Overlay>
              <Box
                backgroundColor={theme.palette.common.white}
                borderRadius={theme.spacing(0.5)}
                padding={6}
                width="40%"
                textAlign="center"
              >
                <Typography variant="bold">
                  {staticText.funnel.emptyState.heading}
                </Typography>
                <Typography variant="body2" mt={2}>
                  {staticText.funnel.emptyState.description}
                </Typography>
              </Box>
            </Overlay>
          )}
          <Box
            gridRow={1}
            gridColumn={1}
            sx={{
              ...(((isFetching && showLoading) || funnelEmpty) && loadingAndEmptyBlur),
            }}
          >
            <Box
              sx={{
                display: 'grid',
                gridTemplateRows: 'auto 1fr',
                gridTemplateColumns: `repeat(${formattedFunnel.length}, 1fr)`,
                columnGap: theme.spacing(3),
                rowGap: theme.spacing(1.5),
              }}
            >
              {formattedFunnel.map((event, i) => (
                <FunnelBar key={event.stage} event={event} delay={i * 100} />
              ))}
              {formattedFunnel.map(event => (
                <FunnelStepDescription key={event.stage} event={event} />
              ))}
            </Box>
          </Box>
        </React.Fragment>
      )}
    </Box>
  );
};

export default ConnectInsightsFunnel;

ConnectInsightsFunnel.propTypes = {
  funnel: arrayOf(shape({
    count: string.isRequired,
    stage: string.isRequired,
    order: number.isRequired,
    displayName: string.isRequired,
    percent: string.isRequired,
  })).isRequired,
  funnelGated: bool.isRequired,
  isFetching: bool.isRequired,
  showLoading: bool.isRequired,
};
